<div class="space-y-6">
  <div class="flex items-center justify-between">
    <h1 class="text-2xl font-bold text-gray-900">Prescriptions</h1>
    <app-button variant="primary" (clicked)="openAddModal()">
      <svg class="w-5 h-5 inline mr-2" fill="none" stroke="currentColor" viewBox="0 0 24 24">
        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M12 4v16m8-8H4" />
      </svg>
      New Prescription
    </app-button>
  </div>

  <div class="card overflow-hidden">
    <div class="overflow-x-auto">
      <table class="min-w-full divide-y divide-gray-200">
        <thead class="bg-gray-50">
          <tr>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Patient</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Date</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Medications</th>
            <th class="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase">Status</th>
            <th class="px-6 py-3 text-right text-xs font-medium text-gray-500 uppercase">Actions</th>
          </tr>
        </thead>
        <tbody class="bg-white divide-y divide-gray-200">
          @if (prescriptions().length === 0) {
            <tr>
              <td colspan="5" class="px-6 py-8 text-center text-gray-500">No prescriptions found</td>
            </tr>
          } @else {
            @for (prescription of prescriptions(); track prescription.id) {
              <tr class="hover:bg-gray-50">
                <td class="px-6 py-4 whitespace-nowrap text-sm font-medium text-gray-900">
                  {{ prescription.patientName }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                  {{ prescription.date | date:'short' }}
                </td>
                <td class="px-6 py-4 text-sm text-gray-900">
                  {{ getMedicationNames(prescription.medications) }}
                </td>
                <td class="px-6 py-4 whitespace-nowrap">
                  <span class="px-2 py-1 text-xs font-medium rounded-full"
                        [ngClass]="{
                          'bg-green-100 text-green-800': prescription.status === 'Active',
                          'bg-gray-100 text-gray-800': prescription.status === 'Completed',
                          'bg-red-100 text-red-800': prescription.status === 'Cancelled'
                        }">
                    {{ prescription.status }}
                  </span>
                </td>
                <td class="px-6 py-4 whitespace-nowrap text-right text-sm font-medium">
                  <button (click)="openEditModal(prescription)" class="text-primary-600 hover:text-primary-900 mr-4">View</button>
                  <app-button variant="danger" (clicked)="deletePrescription(prescription.id)">Delete</app-button>
                </td>
              </tr>
            }
          }
        </tbody>
      </table>
    </div>
  </div>

  @if (showModal()) {
    <div class="fixed inset-0 bg-black bg-opacity-50 flex items-center justify-center z-50" (click)="closeModal()">
      <div class="bg-white rounded-lg shadow-xl max-w-3xl w-full mx-4 max-h-[90vh] overflow-y-auto" (click)="$event.stopPropagation()">
        <div class="p-6 border-b">
          <h2 class="text-xl font-semibold text-gray-900">
            {{ editingPrescription() ? 'Edit Prescription' : 'New Prescription' }}
          </h2>
        </div>
        <div class="p-6 space-y-4">
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Patient</label>
            <select [(ngModel)]="prescriptionForm().patientId" (change)="onPatientSelect($any($event.target).value)" class="input-field">
              <option value="">Select Patient</option>
              @for (patient of patients(); track patient.id) {
                <option [value]="patient.id">{{ patient.firstName }} {{ patient.lastName }}</option>
              }
            </select>
          </div>
          <div>
          <div>
            <label class="block text-sm font-medium text-gray-700 mb-1">Date</label>
            <input type="date" [value]="prescriptionForm().date ? (prescriptionForm().date | date:'yyyy-MM-dd') : ''" 
                   (input)="onDateChange(($any($event.target)).value)" class="input-field" />
          </div>
          </div>
          <div>
            <div class="flex items-center justify-between mb-2">
              <label class="block text-sm font-medium text-gray-700">Medications</label>
              <button (click)="addMedication()" class="text-sm text-primary-600 hover:text-primary-700">+ Add Medication</button>
            </div>
            @for (med of prescriptionForm().medications; track $index) {
              <div class="border rounded-lg p-4 mb-3 space-y-3">
                <div class="grid grid-cols-2 gap-3">
                  <div>
                    <label class="block text-xs font-medium text-gray-700 mb-1">Medication Name</label>
                    <input type="text" [(ngModel)]="med.name" class="input-field text-sm" />
                  </div>
                  <div>
                    <label class="block text-xs font-medium text-gray-700 mb-1">Dosage</label>
                    <input type="text" [(ngModel)]="med.dosage" class="input-field text-sm" />
                  </div>
                </div>
                <div class="grid grid-cols-3 gap-3">
                  <div>
                    <label class="block text-xs font-medium text-gray-700 mb-1">Frequency</label>
                    <input type="text" [(ngModel)]="med.frequency" class="input-field text-sm" />
                  </div>
                  <div>
                    <label class="block text-xs font-medium text-gray-700 mb-1">Duration</label>
                    <input type="text" [(ngModel)]="med.duration" class="input-field text-sm" />
                  </div>
                  <div>
                    <label class="block text-xs font-medium text-gray-700 mb-1">Quantity</label>
                    <input type="number" [(ngModel)]="med.quantity" class="input-field text-sm" />
                  </div>
                </div>
                @if (prescriptionForm().medications!.length > 1) {
                  <app-button variant="danger" size="sm" (clicked)="removeMedication($index)">Remove</app-button>
                }
              </div>
            }
          </div>
        </div>
        <div class="p-6 border-t flex justify-end space-x-3">
          <app-button variant="secondary" (clicked)="closeModal()">Cancel</app-button>
          <app-button variant="primary" (clicked)="savePrescription()">Save</app-button>
        </div>
      </div>
    </div>
  }
</div>

